import { Component, EventEmitter, Input, Output, OnInit, AfterViewInit } from '@angular/core';
import { HttpClient, HttpHeaders } from "@angular/common/http";
import Cookies from 'js-cookie';
import { environment } from "../../../environments/environment";

@Component({
    selector: 'app-view-img',
    templateUrl: './app-view-img.component.html'
})

export class AppButtonViewComponent implements OnInit, AfterViewInit {

    @Input('label') button_label: string;
    @Input('loan_id') loan_id: string;
    @Input('img_type') img_type: string;
    @Output('retrieveImg') emitData: any = new EventEmitter();
    isLoading: boolean = false;

    constructor(private http: HttpClient) {
        console.log('AppButtonViewComponent => constructor');
    }

    ngOnInit() {
        console.log('AppButtonViewComponent => ngOnInit');
    }

    ngAfterViewInit() {
        console.log('AppButtonViewComponent => ngAfterViewInit');
    }

    retrieveImg(): void {
        this.isLoading = true;

        let httpOptions = {
            withCredentials: true,
            headers: null
        };

        if (Cookies.get('csrftoken')) {
            httpOptions = {
                withCredentials: true,
                headers: new HttpHeaders({
                    'X-CSRFToken': Cookies.get('csrftoken')
                })
            };
        }
        
        this.http.get(environment.apiUrl + 'kyc/?loan_id=' + this.loan_id + '&img_type=' + this.img_type, httpOptions)
            .subscribe((resp: any) => {
                this.emitData.emit(resp);
                this.isLoading = false;
            }, () => { 
                this.isLoading = false;
                alert('Unexpected error...please try again later.') 
            });
    }
}



// WEBPACK FOOTER //
// /opt/tglfc/olap/salary_web/src/app/components/app-view-img/app-view-img.component.ts